module.exports = __webpack_public_path__ + "img/collaps-toggle.738d72f1.svg";